import React from 'react';
import PrivateLayout from './PrivateLayout';
import PublicLayout from './PublicLayout';

const SelectLayout = ({ children }) => {
  const isLoggedIn = localStorage.getItem('status') === 'loggedin';

  const Layout = isLoggedIn ? PrivateLayout : PublicLayout;

  return <Layout>{children}</Layout>;
};

export default SelectLayout;